import type { FC } from 'react';
import { FooterLeftBlock } from '@components/Footer/_partials/FooterLeftBlock';
import { FooterRightBlock } from '@components/Footer/_partials/FooterRightBlock';
import { useTranslation } from 'react-i18next';
import type { TFooterProps } from '@components/Footer/Footer.types';

const Footer: FC<TFooterProps> = ({
  logo = `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/logo/reverse-logotype.svg`,
  payoff = `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/logo/reverse-payoff.svg`,
}) => {
  const { t } = useTranslation();

  const defaultMenu = [
    {
      label: t('footer.menu.contact.label'),
      url: t('footer.menu.contact.url'),
    },
    {
      label: t('footer.menu.legal.label'),
      url: t('footer.menu.legal.url'),
    },
    {
      label: t('footer.menu.cookies.label'),
      url: t('footer.menu.cookies.url'),
    },
  ];

  const menu =
    window.employer_locale === 'de'
      ? [
          ...defaultMenu,
          {
            label: t('footer.menu.impressum.label'),
            url: t('footer.menu.impressum.url'),
          },
        ]
      : defaultMenu;

  return (
    <div className="c-app-footer">
      <div className="rev-o-container">
        <div className="rev-o-grid">
          <div className="rev-o-col-12 rev-u-px-16">
            <div className="c-footer c-footer--top-bordered c-footer--top-spaced">
              <div className="c-footer__section c-footer__left">
                <div className="company-info">
                  <div className="c-footer__logotype">
                    <img alt="Logo Reverse" src={logo} />
                  </div>

                  <div
                    className="c-footer__text-block"
                    data-testid="footer-block-left"
                  >
                    <FooterLeftBlock />
                  </div>
                </div>
              </div>

              <div className="c-footer__section c-footer__right">
                <div className="c-footer__payoff">
                  <img alt="" src={payoff} />
                </div>
              </div>

              <div
                className="c-footer__section c-footer__center"
                data-testid="footer-block-right"
              >
                <FooterRightBlock />
              </div>

              <div className="c-footer__section c-footer__bottom">
                <ul
                  className="c-footer__secondary-nav"
                  data-testid="footer-nav-secondary"
                >
                  {menu.map(item => (
                    <li className="c-footer__secondary-nav-item" key={item.url}>
                      <a href={item.url} rel="noreferrer" target="_blank">
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
